
export const moneyAccountLocation = "/settings/moneyaccounts";
